import React, { useEffect, useState } from "react";
import { instanceMob } from "../../../utils/utils";
import useLocationStore from "../config/use-location-store";
import {useNavigate} from "react-router-dom";

const RecentMovementsPanel = () => {
    const [movements, setMovements] = useState([]);
    const navigate = useNavigate();
    const { selectedLocation } = useLocationStore();

    useEffect(() => {
        if (!selectedLocation) return;

        instanceMob
            .get(`/admin/accounting/movements/list?location_id=${selectedLocation.id}`)
            .then((res) => {
                const mapped = res.data.results.map((item, index) => {
                    let typeLabel = "N/A";
                    let typeClass = "chip-type info";

                    switch (item.flag) {
                        case 10:
                            typeLabel = "Venta";
                            typeClass = "chip-type success";
                            break;
                        case 20:
                            typeLabel = "Compra";
                            typeClass = "chip-type warning";
                            break;
                        case 30:
                            typeLabel = "Recibo";
                            typeClass = "chip-type info";
                            break;
                        case 40:
                            typeLabel = "Comprobante";
                            typeClass = "chip-type info";
                            break;
                        case 50:
                            typeLabel = "Préstamo";
                            typeClass = "chip-type info";
                            break;
                        default:
                            typeLabel = item.type || "Desconocido";
                            typeClass = "chip-type info";
                    }

                    let totalQuantity = item.quantity || 0;
                    let totalPrice = item.price || 0;
                    let totalAmount = item.total || 0;
                    if (item.flag === 10 && Array.isArray(item.products)) {
                        totalQuantity = item.products.reduce(
                            (sum, p) => sum + (p.quantity || 0), 0
                        );
                        totalPrice = item.products.reduce(
                            (sum, p) => sum + (p.price || 0), 0
                        );
                        totalAmount = totalPrice;
                    }

                    return {
                        id: item.registry_number || index,
                        type: { label: typeLabel, className: typeClass },
                        responsible: item.responsible || "Sin asignar",
                        description: item.description || item.product || "N/A",
                        customer: item.customer || "N/A",
                        quantity: item.quantity === "N/A" ? "-" : totalQuantity,
                        price: `$${item.price?.toLocaleString() || totalAmount}`,
                        total: `$${item.total?.toLocaleString() || "0"}`,
                        payment_method: item.payment_method || item.other_payment_method || "N/A",
                    };
                });

                setMovements(mapped);
            })
            .catch((err) => {
                console.error("Error al obtener movimientos:", err);
            });
    }, [selectedLocation]);

    return (
        <div className="accounting-dashboard-recent-movements-panel d-flex flex-column p-4 py-4 gap-3">
            <div className="d-flex flex-row justify-content-between align-items-center">
                <div className="accounting-dashboard-recent-movements-panel-title">
                    Movimientos Recientes
                </div>

                <div className="d-flex flex-row gap-2 align-items-center cursor-pointer" onClick={() => {navigate("/accounting/incomes-expenses")}}>
                    <div className="accounting-dashboard-recent-movements-panel-action-label">
                        Ir a la página de movimientos
                    </div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M18 12L18.7071 12.7071L19.4142 12L18.7071 11.2929L18 12ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13L6 12L6 11ZM14 16L14.7071 16.7071L18.7071 12.7071L18 12L17.2929 11.2929L13.2929 15.2929L14 16ZM18 12L18.7071 11.2929L14.7071 7.29289L14 8L13.2929 8.70711L17.2929 12.7071L18 12ZM18 12L18 11L6 11L6 12L6 13L18 13L18 12Z"
                            fill="#9DACBD"
                        />
                    </svg>
                </div>
            </div>

            <div className="accounting-dashboard-recent-movements-scroll-table">
                <table className="accounting-dashboard-recent-movements-table table table-hover align-middle table-borderless mb-0">
                    <thead>
                    <tr>
                        <th scope="col">Registro</th>
                        <th scope="col" className="text-center">
                            Tipo
                        </th>
                        <th scope="col">Vendedor</th>
                        <th scope="col">Concepto</th>
                        <th scope="col">Comprador</th>
                        <th scope="col">Cantidad</th>
                        <th scope="col">Precio</th>
                        <th scope="col">Total</th>
                        <th scope="col">Medio de Pago</th>
                    </tr>
                    </thead>
                    <tbody>
                    {movements.map((mov) => (
                        <tr key={mov.id}>
                            <td className="py-3">{mov.id}</td>
                            <td className="py-3 text-center">
                                <span className={mov.type.className}>{mov.type.label}</span>
                            </td>
                            <td className="py-3">{mov.responsible}</td>
                            <td className="py-3">{mov.description}</td>
                            <td className="py-3">{mov.customer}</td>
                            <td className="py-3">{mov.quantity}</td>
                            <td className="py-3">{mov.price}</td>
                            <td className="py-3">{mov.total}</td>
                            <td className="py-3">{mov.payment_method}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RecentMovementsPanel;
